import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { changeLanguage } from "../../../store/actions/menu";
import { availableLanguages } from "../../../constants/utils";
import IconButton from "@material-ui/core/IconButton";
import LanguageIcon from "@material-ui/icons/Language";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import { makeStyles } from "@material-ui/core/styles";
import LanguageSwitcherStyle from "./languageSwitcherStyle";

const useStyles = makeStyles(LanguageSwitcherStyle);

const HeaderLanguageSwitcher = () => {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const menuInfo = useSelector((state) => state.menuInfo);
  const { menuData, languages, selected_language } = menuInfo;
  const { theme_data, license } = menuData;

  const [langAnchorEl, setLangAnchorEl] = React.useState(null);

  const handleLanguageClick = (event) => {
    setLangAnchorEl(event.currentTarget);
  };

  const handleLanguageClose = () => {
    setLangAnchorEl(null);
  };

  const handleLanguageSelection = (langCode) => {
    const segments = location.pathname.split("/").filter(Boolean);
    const validLangs = availableLanguages.map((lang) => lang.code);
    let subPathSegments = segments;

    // If the first segment is a valid lang code, that means
    // we do have a language prefix in the URL
    if (validLangs.includes(segments[0])) {
      subPathSegments = segments.slice(1);
      // e.g. ["product", "123"]
    }
    const newPath = `/${langCode}/${subPathSegments.join("/")}`;
    dispatch(changeLanguage(license, langCode));
    handleLanguageClose();
    history.push(newPath);
  };

  return (
    <div>
      <IconButton
        style={{
          color: theme_data?.header_menu_icon_color,
          minWidth: 48,
        }}
        color="inherit"
        aria-label="language-menu"
        aria-controls="language-menu"
        aria-haspopup="true"
        onClick={handleLanguageClick}
        className={"language-icon"}
      >
        <div className={classes.selectedLang}>
          {languages.find((l) => l.code === selected_language)?.name_local}
        </div>
        <LanguageIcon />
      </IconButton>
      <Menu
        id="language-menu"
        anchorEl={langAnchorEl}
        keepMounted
        open={Boolean(langAnchorEl)}
        onClose={handleLanguageClose}
      >
        {languages.map((x, i) => (
          <MenuItem
            key={i}
            selected={x.code === selected_language}
            onClick={() => handleLanguageSelection(x.code)}
          >
            {x.name_local}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

export default HeaderLanguageSwitcher;
